fragment ImageOrVideoFragment on imageOrVideo_Entry {
  typeHandle
  alt
  asset {
    ...CraftAssetFragment
  }
  autoplay
  backgroundGray
}
